import { TaxProcedure } from '@carvia/ros-client-types';
import { calculateRentalDays } from '@/utils/calculate-rental-days';
import { normalizeVatId } from '@/utils/vat-id';
import { isEuCountryCode } from '@/utils/eu-countries';

const LONG_RENTAL_DAYS_THRESHOLD = 30;

export function resolveDefaultBookingTaxProcedure(params: {
  startDate: Date | string;
  endDate: Date | string;
  vatId?: string | null;
  country?: string | null;
}): TaxProcedure {
  const normalizedVatId = normalizeVatId(params.vatId ?? undefined);
  if (!normalizedVatId) {
    return TaxProcedure.REGULAR;
  }

  const rentalDays = calculateRentalDays(new Date(params.startDate), new Date(params.endDate));
  if (rentalDays < LONG_RENTAL_DAYS_THRESHOLD) {
    return TaxProcedure.REGULAR;
  }

  const countryFromVatId = normalizedVatId.slice(0, 2);
  const countryCode = (params.country ?? countryFromVatId).trim().toUpperCase();

  if (countryCode === 'DE') {
    return TaxProcedure.REGULAR;
  }

  if (isEuCountryCode(countryCode)) {
    return TaxProcedure.REVERSE_CHARGE;
  }

  return TaxProcedure.EXPORT;
}
